module.exports = __webpack_public_path__ + "static/img/cde.0532b02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/cde.jpg
// module id = x7Lg
// module chunks = 1